/**
 * @name FourDecimalPricingShopping.Entry.js
 * @author Anchor Group : Volodymyr Kira <vkira@anchorgroup.tech>
 * @since 2024-06-18
 * @file adds pricing with four decimals
 */

define('FourDecimalPricingShopping.Entry',
	[
		'BulkOrderPLP_DynamicTables.ItemLines.View',
		"ProductViews.Price.View",
		"Transaction.Line.Views.Price.View",
		"Cart.Item.Summary.View",
		"Cart.Summary.View",
		"Header.MiniCartItemCell.View"
	],
	function (
		BulkOrderPLP_DynamicTablesItemLinesView,
		ProductViewsPriceView,
		TransactionLineViewsPriceView,
		CartItemSummaryView,
		CartSummaryView,
		HeaderMiniCartItemCellView
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				BulkOrderPLP_DynamicTablesItemLinesView.prototype.getContext = _.wrap(BulkOrderPLP_DynamicTablesItemLinesView.prototype.getContext, function (fn) {
					var context = fn.apply(this, _.toArray(arguments).slice(1));
					let fullPrice = this.itemModel.get('onlinecustomerprice').toFixed(4).toString();
					context.onlinecustomerprice_formatted = `$${fullPrice}`;
					return context;
				});

				ProductViewsPriceView.prototype.getContext = _.wrap(ProductViewsPriceView.prototype.getContext, function (fn) {
					var context = fn.apply(this, _.toArray(arguments).slice(1));
					let fullPrice = context.price.toFixed(4).toString();
					context.priceFormatted = `$${fullPrice}`;
					return context;
				});

				TransactionLineViewsPriceView.prototype.getContext = _.wrap(TransactionLineViewsPriceView.prototype.getContext, function (fn) {
					var context = fn.apply(this, _.toArray(arguments).slice(1));
					let fullPrice = context.price.toFixed(4).toString();
					context.rateFormatted = `$${fullPrice}`;
					return context;
				});

				CartItemSummaryView.prototype.getContext = _.wrap(CartItemSummaryView.prototype.getContext, function (fn) {
					var context = fn.apply(this, _.toArray(arguments).slice(1));
					let amount_formattedFullPrice = context.line.get('amount').toFixed(4).toString();
					context.line.set('amount_formatted', amount_formattedFullPrice);
					let totalFormattedFullPrice = context.line.get('total').toFixed(4).toString();
					context.line.set('total_formatted', `$${totalFormattedFullPrice}`);
					return context;
				});

				CartSummaryView.prototype.getContext = _.wrap(CartSummaryView.prototype.getContext, function (fn) {
					var context = fn.apply(this, _.toArray(arguments).slice(1));
					let fullPrice = context.summary.subtotal.toFixed(4).toString();
					context.summary.subtotal_formatted = `$${fullPrice}`;
					return context;
				});

				HeaderMiniCartItemCellView.prototype.getContext = _.wrap(HeaderMiniCartItemCellView.prototype.getContext, function (fn) {
					var context = fn.apply(this, _.toArray(arguments).slice(1));
					let fullPrice = this.model.get('rate').toFixed(4).toString();
					context.line.set('rate_formatted', `$${fullPrice}`);
					return context;
				});
			}
		};
	});
